export default __webpack_public_path__ + "static/media/T_wdt_c_cap_2.9f1fd288.mp3";